module.exports = __webpack_public_path__ + "img/navDrawer.a3be00a5.png";